import { render } from "./SecondaryButton.vue?vue&type=template&id=82943a2e"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__